var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-file',{attrs:{"file":_vm.asset,"show-date":false}})}
var staticRenderFns = []

export { render, staticRenderFns }